import importer from 'common/importer'
/* ALERT */
const alert = importer('Helpers/Alert')
export default function * failure ({ error }) {
  // yield alert(
  //   'Error',
  //   `An error has occurred.\n
  //   Please try again later `
  // )
  // console.log(JSON.stringify(error))
}
